<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="confirmText"
        @confirm="confirm"
    >
        <div class="modal-body">
            <div>
                <div class="row">
                    <img
                        src="@/assets/img/icon/u1280.svg"
                        alt=""
                    />是否删除文件“<span v-text="fileName"></span>” ?
                </div>
                <div class="tips">
                    该操作仅删除云端文件，任务关联网吧/服务器的已下载文件不受影响。
                </div>
                <div class="tips">
                    如需删除网吧/服务器上的文件，请删除相应任务或取消关联网吧。
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import { delFile } from "@/requests/threeTierMission";
export default {
    components: {
        DefaultModal,
    },
    data() {
        return {
            fileId: "",
            fileName: "",
            title: "删除文件",
            confirmText: "",
            successFn: "",
        };
    },
    mounted() {
        window.$modal.delFileModal = {};
        window.$modal.delFileModal.show = (id, fileName) => {
            this.fileId = id;
            this.fileName = fileName;
            this.confirmText = "确认";
            return new Promise((resolve) => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        // 初始化信息
        init(fn) {
            this.$refs.box.show();
            this.successFn = fn;
        },
        async confirm() {
            let resValue = await delFile({
                fileId: this.fileId,
            });
            if (resValue.code == 200) {
                this.$refs.box.hide();
                this.successFn();
            } else {
                this.$refs.box.setWrong(resValue.msg);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.modal-body {
    padding: 10px 0 10px 50px;
    text-align: left;
    .row {
        height: 40px;
    }
    .tips {
        margin-left: 28px;
        font-size: 12px;
    }
    img {
        position: relative;
        top: 5px;
        margin-right: 8px;
    }
}
</style>
